import { SvgIcon } from '@mui/material';
import { forwardRef } from 'react';
import Principal from './Principal.svg';

export const PrincipalIcon = forwardRef(function PrincipalIcon(props, ref) {
  return (
    <SvgIcon {...props} ref={ref} component={Principal} viewBox="0 0 40 40" />
  );
});
